import "./AddModalSortBy.css";

import React, { useContext, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { WidgetContext } from "../../../../../context/WidgetContext";
import SwitchToggle from "../../../switchToggle/SwitchToggle";
import { DatesAndGuests } from "../../widget-form/WidgetForm";
import useWindowSize from "../../../../../_helpers/UseWindowHook";
import ViewPort from "../../../../../_helpers/Enums/ViewPortEnum";

interface AddModalSortProps {
  /* name of the modal to display */
  modalTitle: String,
  /* dates to book and # of guests */
  datesAndGuests: DatesAndGuests,
  /* boolean toggle for thin vs expanded view on VendorCards */
  simpleView: boolean,
  /* stateful method to set simpleView */
  setSimpleView: React.Dispatch<React.SetStateAction<boolean>>,
  /* optional method to filter by Lodging type */
  filterLodging?: (e: any) => void,
  /* method to filter by Pricing */
  filterPricing: (e: any) => void,
  /* cities to sort by */
  cityOptions: string[],
  /* method to filter by City */
  filterCities: (e: any) => void,
  /* whether to show lodging type filter */
  showLodging?: boolean,
}

/* Sort By Component for all Add [Type] Modals */
const AddModalSortBy = (props: AddModalSortProps) => {
  const { style } = useContext(WidgetContext);
  const [datesAndGuests, setDatesAndGuests] = useState<DatesAndGuests>(props.datesAndGuests);
  const { breakPoint } = useWindowSize();

  /* static lodging options */
  const lodgingOptions: { title: string, value: number }[] = [
    { title: 'Sort by - All', value: 0 },
    { title: 'Hotel', value: 1 },
    { title: 'Casino Hotel', value: 2 },
    { title: 'Condos', value: 4 },
    { title: 'Private Homes', value: 8 },
  ]

  /* static pricing options */
  const pricingOptions: string[] = [
    'Sort by - Price',
    'Price Low - High',
    'Price High - Low',
  ]

  return (
    <div className="w-100">
      <Modal.Title className="" style={{ color: style.fontColor }}>{props.modalTitle}</Modal.Title>
      <Row className="" >
        <p style={{ color: style.fontColor }} className="itinerary-info mr-2 mb-0"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.fromDate ? datesAndGuests.fromDate.toDateString() : "Arrive"}</p>
        <p style={{ color: style.fontColor }} className="itinerary-info mb-0"> - </p>
        <p style={{ color: style.fontColor }} className="itinerary-info ml-2 mb-0"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.toDate ? datesAndGuests.toDate.toDateString() : "Depart"}</p>
        {/* Desktop Switch Toggle */}
        {breakPoint >= ViewPort.md && (
          <div style={{ display: 'flex', marginLeft: 'auto', marginRight: 0, marginTop: '10px' }}>
            <p style={{ marginTop: '-4px', marginRight: '4px' }}>Simple View</p>
            <SwitchToggle checked={props.simpleView} id={"lodging-toggle-1"} onChange={props.setSimpleView} />
          </div>
        )}
      </Row>

      <Row>
        {props.showLodging &&
          <Col>
            <Form.Control
              className=""
              style={{ color: style.fontColor }}
              as="select"
              name="lodgingFilters"
              onChange={props.filterLodging} >
              {lodgingOptions.map((lodgingType, index) => (
                <option value={lodgingType.value} key={"lodging_" + index}>{lodgingType.title}</option>
              ))}
            </Form.Control>
          </Col>
        }

        <Col className="">
          <Form.Control
            className=""
            style={{ color: style.fontColor }}
            as="select"
            name="cityFilters"
            onChange={props.filterCities} >
            <option value="">Sort by - City</option>
            {props.cityOptions.map((city: string, index) => (
              <option value={city} key={"city_" + index}>{city}</option>
            ))}
          </Form.Control>
        </Col>
      </Row>

      {/* Mobile Switch Toggle */}
      {breakPoint < ViewPort.md && (
        <div className="mobile-switch-toggle-div">
          <p style={{ marginTop: '-4px', marginRight: '4px' }}>Simple View</p>
          <SwitchToggle checked={props.simpleView} id={"add-modal-toggle-1"} onChange={props.setSimpleView} />
        </div>
      )}
    </div>
  )
}

export default AddModalSortBy;